<template>
  <section>
    <scroll-container
      class="pt-2"
      :height-offset="isInEditMode ? '85px' : '160px'"
    >
      <b-row v-if="loading">
        <b-col
          sm="12"
          class="text-center"
        >
          <b-skeleton
            class="d-inline-block"
            animation="wave"
            width="40%"
            height="700px"
          />
        </b-col>
      </b-row>
      <b-container
        v-else
        class="container-small"
      >
        <b-card
          v-if="isInEditMode"
          class="mb-2"
        >
          <div class="mb-2">
            <b-card-title class="mb-0">
              {{ $tk('ClientPortal.Forms.EditDisplayAdExternal') }}
            </b-card-title>
            <b-breadcrumb class="m-0 p-0">
              <b-breadcrumb-item :to="`/${$route.params.accountId}/campaign/edit/${wrapper.campaignModel.id}`">
                {{ wrapper.campaignModel.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item :to="`/${$route.params.accountId}/adgroup/edit?adGroupId=${wrapper.adGroup.id}&campaignId=${wrapper.campaignModel.id}`">
                {{ wrapper.adGroup.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item active>
                {{ wrapper.displayAdEdit.adName }}
              </b-breadcrumb-item>
            </b-breadcrumb>
            <hr class="m-0 mt-1">
          </div>
          <b-form-group
            class="mb-2"
          >
            <legend class="col-form-label pt-0">
              {{ $tk('ClientPortal.Form.AdCreation.AdFormats') }} *
              <GjIcon
                v-b-tooltip.hover.bottom="$tk('ClientPortal.Form.AdFormatsTooltip')"
                name="Info"
              />
            </legend>
            <b-form-row>
              <b-col :sm="adsLength ? 11 : 12">
                <v-select
                  v-model="wrapper.displayAdEdit.formatId"
                  :clearable="false"
                  label="name"
                  :options="wrapper.adFormats"
                  :reduce="format => format.id"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.AdName') + ' *'"
            :invalid-feedback="wrapper.displayAdEdit.errors['AdName']"
            :state="wrapper.displayAdEdit.errors['AdName'] == null ? null : false"
          >
            <b-form-row>
              <b-col sm="11">
                <AdNameField
                  :id="'ad-name-'+wrapper.displayAdEdit.id"
                  v-model="wrapper.displayAdEdit.adName"
                  :variables="adNameVariables"
                  :placeholder="$tk('ClientPortal.Form.AdNamePlaceholder')"
                  :state="wrapper.displayAdEdit.errors['AdName'] == null ? null : false"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(wrapper.displayAdEdit.id,'name')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.ExternalAdsHtml') + ' *'"
            :invalid-feedback="wrapper.displayAdEdit.errors['Subtype']"
            :state="wrapper.displayAdEdit.errors['Subtype'] == null ? null : false"
          >
            <b-form-row>
              <b-col sm="11">
                <b-form-textarea
                  :id="'ad-html-'+wrapper.displayAdEdit.id"
                  v-model="wrapper.displayAdEdit.externalContent"
                  :placeholder="$tk('ClientPortal.Form.ExternalAdsHtmlPlaceholder')"
                  rows="3"
                  :state="wrapper.displayAdEdit.errors['Subtype'] == null ? null : false"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(wrapper.displayAdEdit.id,'html')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.Url') + ' *'"
            :invalid-feedback="wrapper.displayAdEdit.errors['Url']"
            :state="wrapper.displayAdEdit.errors['Url'] == null ? null : false"
          >
            <b-form-row>
              <b-col sm="11">
                <b-form-input
                  :id="'ad-url-'+wrapper.displayAdEdit.id"
                  v-model="wrapper.displayAdEdit.url"
                  type="text"
                  :placeholder="$tk('ClientPortal.Form.URLTooltip')"
                  :state="wrapper.displayAdEdit.errors['Url'] == null ? null : false"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(wrapper.displayAdEdit.id,'url')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-button
            v-b-toggle="'url-builder-'+index"
            class="bg-white mb-2"
            size="sm"
            variant="outline-primary"
          >
            <GjIcon
              class="mr-50"
              name="Hyperlink"
            />
            <span class="when-open">
              {{ $tk('ClientFormat.Form.CloseUrlBuilder') }}
              <GjIcon
                class="mr-50"
                name="ArrowUp"
              />
            </span>
            <span class="when-closed">
              {{ $tk('ClientFormat.Form.OpenUrlBuilder') }}
              <GjIcon
                class="mr-50"
                name="ArrowDown"
              />
            </span>
          </b-button>
          <b-collapse
            :id="'url-builder-'+index"
          >
            <url-builder
              :ref="'utm'+index"
              :key="index"
              v-model="wrapper.displayAdEdit.url"
              :options="wrapper.utmOptions"
            />
          </b-collapse>
          <b-form-group
            class="mb-0"
          >
            <legend class="col-form-label pt-0">
              {{ $tk('ClientPortal.Form.ImpressionTag') }}
              <GjIcon
                v-b-tooltip.hover="$tk('ClientPortal.Form.ImpressionTagTooltip')"
                name="Info"
              />
            </legend>
            <b-form-row>
              <b-col sm="11">
                <b-form-input
                  :id="'ad-impressionTag-'+wrapper.displayAdEdit.id"
                  v-model="wrapper.displayAdEdit.impressionTag"
                  type="text"
                  :placeholder="$tk('ClientPortal.Form.ImpressionTagPlaceholder')"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(wrapper.displayAdEdit.id,'impressionTag')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-card-title
            v-b-toggle="`collapse-ad-preview-${wrapper.displayAdEdit.id}`"
            class="d-flex justify-content-between py-2 mb-0"
            @click="showDisplayAd(wrapper.displayAdEdit)"
          >
            <div
              class="text-primary d-flex align-items-center"
            >
              <GjIcon name="Show" />
              {{ $tk('ClientPortal.Form.AdCreation.AdPreview') }}
            </div>
            <span class="when-open">
              <GjIcon name="ArrowUp" />
            </span>
            <span class="when-closed">
              <GjIcon name="ArrowDown" />
            </span>
          </b-card-title>
          <b-collapse
            :id="`collapse-ad-preview-${wrapper.displayAdEdit.id}`"
          >
            <a
              v-if="wrapper.displayAdEdit.externalContent !== ''"
              :href="wrapper.displayAdEdit.url"
              target="_blank"
            >
              <!--eslint-disable-next-line vue/no-v-html-->
              <div
                class="content ml-0"
                v-html="decodeURIComponent(wrapper.displayAdEdit.externalContent)"
              />
            </a>
            <div v-else class="text-center">
              <span>
                {{ $tk('ClientPortal.Form.AdCreation.NoHtmlHasBeenWrittenYet') }}
              </span>
            </div>
          </b-collapse>
        </b-card>
        <b-card
          v-for="(displayAd, index) in wrapper.displayAds"
          v-else
          :key="index"
          class="mb-2"
        >
          <div
            v-if="index === 0"
            class="mb-2"
          >
            <b-card-title class="mb-0">
              {{ $tk('ClientPortal.Forms.NewDisplayAdExternal') }}
            </b-card-title>
            <b-breadcrumb class="m-0 p-0">
              <b-breadcrumb-item :to="`/${$route.params.accountId}/campaign/create/${wrapper.campaignModel.id}`">
                {{ wrapper.campaignModel.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item :to="`/${$route.params.accountId}/adgroup/create?adGroupId=${wrapper.adGroup.id}&campaignId=${wrapper.campaignModel.id}`">
                {{ wrapper.adGroup.name }}
              </b-breadcrumb-item>
              <b-breadcrumb-item active>
                {{ $tk('ClientPortal.Form.NewAd') }}
              </b-breadcrumb-item>
            </b-breadcrumb>
            <hr class="m-0 mt-1">
          </div>
          <!-- <b-card-title>
            {{ $tk('ClientPortal.Form.AdCreation.ExternalAds') }}
          </b-card-title> -->
          <b-form-group
            class="mb-2"
          >
            <legend class="col-form-label pt-0">
              {{ $tk('ClientPortal.Form.AdCreation.AdFormats') }} *
              <GjIcon
                v-b-tooltip.hover.bottom="$tk('ClientPortal.Form.AdFormatsTooltip')"
                name="Info"
              />
            </legend>
            <b-form-row>
              <b-col :sm="adsLength ? 11 : 12">
                <v-select
                  v-model="displayAd.formatId"
                  :clearable="false"
                  label="name"
                  :placeholder="$tk('ClientPortal.Form.ChooseAdFormat')"
                  :options="wrapper.adFormats"
                  :reduce="format => format.id"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
              >
                <b-button
                  v-if="adsLength"
                  variant="link"
                  size="sm"
                  @click="removeDisplayAd(displayAd.id)"
                >
                  <GjIcon
                    class="cursor-pointer text-secondary"
                    name="Delete"
                  />
                </b-button>
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.AdName') + ' *'"
            :invalid-feedback="displayAd.errors['AdName']"
            :state="displayAd.errors['AdName'] == null ? null : false"
          >
            <b-form-row>
              <b-col sm="11">
                <AdNameField
                  :id="'ad-name-'+displayAd.id"
                  v-model="displayAd.adName"
                  :variables="adNameVariables"
                  :placeholder="$tk('ClientPortal.Form.AdNamePlaceholder')"
                  :state="displayAd.errors['AdName'] == null ? null : false"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(displayAd.id,'name')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.ExternalAdsHtml') + ' *'"
            :invalid-feedback="displayAd.errors['Subtype']"
            :state="displayAd.errors['Subtype'] == null ? null : false"
          >
            <b-form-row>
              <b-col sm="11">
                <b-form-textarea
                  :id="'ad-html-'+displayAd.id"
                  v-model="displayAd.externalContent"
                  :placeholder="$tk('ClientPortal.Form.ExternalAdsHtmlPlaceholder')"
                  rows="3"
                  :state="displayAd.errors['Subtype'] == null ? null : false"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(displayAd.id,'html')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group
            class="mb-2"
            :label="$tk('ClientPortal.Form.Url') + ' *'"
            :invalid-feedback="displayAd.errors['Url']"
            :state="displayAd.errors['Url'] == null ? null : false"
          >
            <b-form-row>
              <b-col sm="11">
                <b-form-input
                  :id="'ad-url-'+displayAd.id"
                  v-model="displayAd.url"
                  type="text"
                  :placeholder="$tk('ClientPortal.Form.URLTooltip')"
                  :state="displayAd.errors['Url'] == null ? null : false"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(displayAd.id,'url')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-button
            v-b-toggle="'url-builder-'+index"
            class="bg-white mb-2"
            size="sm"
            variant="outline-primary"
          >
            <GjIcon
              class="mr-50"
              name="Hyperlink"
            />
            <span class="when-open">
              {{ $tk('ClientFormat.Form.CloseUrlBuilder') }}
              <GjIcon
                class="mr-50"
                name="ArrowUp"
              />
            </span>
            <span class="when-closed">
              {{ $tk('ClientFormat.Form.OpenUrlBuilder') }}
              <GjIcon
                class="mr-50"
                name="ArrowDown"
              />
            </span>
          </b-button>
          <b-collapse
            :id="'url-builder-'+index"
          >
            <url-builder
              :ref="'utm'+index"
              :key="index"
              v-model="displayAd.url"
              :options="wrapper.utmOptions"
            />
          </b-collapse>
          <b-form-group
            class="mb-0"
          >
            <legend class="col-form-label pt-0">
              {{ $tk('ClientPortal.Form.ImpressionTag') }}
              <GjIcon name="Info" />
            </legend>
            <b-form-row>
              <b-col sm="11">
                <b-form-input
                  :id="'ad-impressionTag-'+displayAd.id"
                  v-model="displayAd.impressionTag"
                  type="text"
                  :placeholder="$tk('ClientPortal.Form.ImpressionTagPlaceholder')"
                />
              </b-col>
              <b-col
                class="pt-1 pt-sm-50 d-flex flex-row-reverse flex-sm-row"
                sm="1"
                @click="copyText(displayAd.id,'impressionTag')"
              >
                <GjIcon
                  class="cursor-pointer"
                  name="Copy"
                />
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-card-title
            v-b-toggle="`collapse-ad-preview-${displayAd.id}`"
            class="d-flex justify-content-between py-2 mb-0"
            @click="showDisplayAd(displayAd)"
          >
            <div
              class="text-primary d-flex align-items-center"
            >
              <GjIcon name="Show" />
              {{ $tk('ClientPortal.Form.AdCreation.AdPreview') }}
            </div>
            <span class="when-open">
              <GjIcon name="ArrowUp" />
            </span>
            <span class="when-closed">
              <GjIcon name="ArrowDown" />
            </span>
          </b-card-title>
          <b-collapse
            :id="`collapse-ad-preview-${displayAd.id}`"
          >
            <a
               v-if="displayAd.externalContent !== ''"
              :href="displayAd.url"
              target="_blank"
            >
              <!--eslint-disable-next-line vue/no-v-html-->
              <div
                class="content ml-0"
                v-html="displayAd.externalContent"
              />
            </a>
            <div v-else class="text-center">
              <span>
                {{ $tk('ClientPortal.Form.AdCreation.NoHtmlHasBeenWrittenYet') }}
              </span>
            </div>
          </b-collapse>
        </b-card>
        <b-button
          v-if="!isInEditMode"
          class="bg-white mb-3"
          variant="outline-primary"
          size="sm"
          @click="addExternalAd()"
        >
          <GjIcon
            class="mr-50"
            name="Plus"
          />
          {{ $tk('ClientPortal.Form.AddExternalAdvertisementCode') }}
        </b-button>
      </b-container>
    </scroll-container>
    <div class="border-top text-right py-1">
      <div class="container-small mx-auto">
        <b-button
          v-if="isInEditMode"
          class="bg-white"
          variant="outline-dark"
          size="sm"
          :disabled="saving"
          @click="closeEditModal"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          v-else
          :to="`/${$route.params.accountId}/`"
          class="bg-white"
          variant="outline-dark"
          size="sm"
          :disabled="saving"
        >
          {{ $tk('ClientPortal.Form.Actions.Cancel') }}
        </b-button>
        <b-button
          class="bg-white ml-50"
          variant="primary"
          size="sm"
          :disabled="saving || !isFormComplete"
          @click="saveDisplayAd()"
        >
          {{ isInEditMode ? $tk('ClientPortal.Form.Actions.Save') : $tk('ClientPortal.Form.Actions.CreateAd') }}
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import notification from '@/mixins/toastification'
import sweetAlert from '@/mixins/sweetAlert'
import ScrollContainer from '@/components/ScrollContainer.vue'
import UrlBuilder from '@/components/UrlBuilder.vue'
import AdsService from '@/api/client/ads.service'
import vSelect from 'vue-select'
import scrollToError from '@/mixins/scrollToError'
import AdNameField from '@/components/AdNameField.vue'
import { AD_NAME_VARIABLES, findUnknownTokens } from '@/utils/adNameTokens'

const ADSUBTYPE_DISPLAY_EXTERNAL = 3
export default {
  inject: ['closeEditModal'],
  components: {
    GjIcon,
    ScrollContainer,
    UrlBuilder,
    vSelect,
    AdNameField,
  },
  mixins: [notification, sweetAlert],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    adId: Number,
    // eslint-disable-next-line vue/require-default-prop
    adGroupId: Number,
    // eslint-disable-next-line vue/require-default-prop
    catalogSetId: {
      type: String,
    },
    saving: {
      type: Boolean,
    },
  },
  data() {
    return {
      wrapper: {},
      adFormats: [],
      count: 1,
      loading: false,
    }
  },
  computed: {
    adsLength() {
      return this.wrapper.displayAds.length > 1
    },
    isFormComplete() {
      if (this.isInEditMode) {
        const { displayAdEdit } = this.wrapper
        return displayAdEdit && displayAdEdit.adName && displayAdEdit.url && displayAdEdit.formatId && displayAdEdit.externalContent
      }
      const { displayAds } = this.wrapper
      return displayAds && displayAds.length && displayAds.every(x => x.adName && x.url && x.formatId && x.externalContent)
    },
    isInEditMode() {
      return this.adId > 0
    },
    adNameVariables() {
      return AD_NAME_VARIABLES
    },
  },
  async mounted() {
    this.loading = true
    try {
      this.wrapper = await AdsService.getAd(this.adId, this.adGroupId, this.catalogSetId, this.$route.params.accountId)
    } catch (error) {
      this.error(this.$tk('ClientPortal.Form.FailedToLoadData'))
    } finally {
      if (!this.isInEditMode) {
        this.addDefaultExternalAd()
      } else {
        this.wrapper.displayAdEdit.externalContent = decodeURIComponent(this.wrapper.displayAdEdit.externalContent)
      }
      this.loading = false
    }
  },
  methods: {
    setSaving(value) {
      this.$emit('onUpdate', value)
    },
    async showDisplayAd(displayAd) {
      try {
        const response = await AdsService.sanitazeUrl(displayAd.url)
        displayAd.url = response
      } catch (error) {
        this.error(error.message)
      }
    },
    removeDisplayAd(id) {
      if (this.wrapper.displayAds.length > 1) {
        const index = this.wrapper.displayAds.findIndex(x => x.id === id)
        if (index > -1) {
          this.wrapper.displayAds.splice(index, 1)
        }
      }
    },
    copyText(id, type) {
      const element = `ad-${type}-${id}`
      const copyText = document.getElementById(element)
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
    },
    validateAdName(ad) {
      if (!ad.errors) this.$set(ad, 'errors', {})
      this.$set(ad.errors, 'AdName', null)
      const unknown = findUnknownTokens(ad.adName)
      if (unknown.length > 0) {
        const tokens = unknown.map(k => `{{${k}}}`).join(', ')
        this.$set(ad.errors, 'AdName', `Unknown variables: ${tokens}`)
        return false
      }
      return true
    },
    async saveDisplayAd() {
      this.setSaving(true)

      if (this.isInEditMode) {
        if (!this.validateAdName(this.wrapper.displayAdEdit)) {
          this.setSaving(false)
          this.$nextTick(() => scrollToError(this.wrapper.displayAdEdit.errors))
          return
        }
        const { entity } = this.$parent.$parent.$parent
        this.escapeImpressionAndExternalContent([this.wrapper.displayAdEdit])
        try {
          const response = await AdsService.editDisplayAd(this.wrapper.displayAdEdit, this.$route.params.accountId)
          if (response.updated) {
            const resolvedName = response.adName || (response.displayAdModel && response.displayAdModel.adName) || this.wrapper.displayAdEdit.adName
            this.wrapper.displayAdEdit.adName = resolvedName
            entity.name = resolvedName
            this.success(response.message)
            this.closeEditModal()
          } else {
            this.error(response.message)
            this.wrapper.displayAdEdit = response.displayAdModel
            this.$nextTick(() => {
              scrollToError(this.wrapper.displayAdEdit.errors)
            })
          }
        } catch (error) {
          this.error(error.message)
        } finally {
          this.setSaving(false)
        }
      } else if (this.wrapper.displayAds.length > 0) {
        let hasInvalid = false
        this.wrapper.displayAds.forEach(ad => {
          if (!this.validateAdName(ad)) hasInvalid = true
        })
        if (hasInvalid) {
          this.$nextTick(() => {
            const firstInvalidInput = document.querySelector('.is-invalid')
            if (firstInvalidInput) {
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          })
          this.setSaving(false)
          return
        }
        this.escapeImpressionAndExternalContent(this.wrapper.displayAds)
        try {
          const response = await AdsService.createDisplayAd(ADSUBTYPE_DISPLAY_EXTERNAL, this.wrapper.displayAds, this.$route.params.accountId)
          if (response.saved) {
            this.wrapper.displayAds = []
            this.sweetAlertAfterAdCreation()
          } else {
            this.wrapper.displayAds = response.displayAds
            this.error(this.$tk('ClientPortal.Ads.ErrorSavingChanges'))
            this.$nextTick(() => {
              const firstInvalidInput = document.querySelector('.is-invalid')
              if (firstInvalidInput) {
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' })
              }
            })
            this.setSaving(false)
          }
        } catch (error) {
          this.error(error.message)
          this.setSaving(false)
        }
      }
    },
    addExternalAd() {
      // eslint-disable-next-line no-plusplus
      this.count++
      this.wrapper.displayAds.push({
        id: this.count,
        adName: '',
        mediaUrl: '',
        url: '',
        formatId: 4,
        adGroupId: this.wrapper.adGroup.id,
        externalContent: '',
        impressionTag: '',
        show: false,
        errors: {},
      })
    },
    escapeImpressionAndExternalContent(displayAds) {
      displayAds.forEach(element => {
        element.impressionTag = encodeURIComponent(element.impressionTag)
        element.externalContent = encodeURIComponent(element.externalContent)
        element.mediaUrl = 'external'
      })
    },
    addDefaultExternalAd() {
      this.wrapper.displayAds.push(
        {
          id: this.count,
          adName: '',
          // fileWidth: 728,
          // fileHeight: 90,
          mediaUrl: 'test',
          url: '',
          formatId: 4,
          adGroupId: this.wrapper.adGroup.id,
          externalContent: '',
          impressionTag: '',
          show: false,
          errors: {},
        },
      )
    },
  },
}
</script>
